module.exports={
    base_url:"https://neo-api.patjarmerah.com"
    // base_url:"https://patjarmerah-dev-api.intellivent.id"
    // base_url:"https://intellivent.id/test-api"
};
